/**
 * Confirmation dialog used for destructive actions — wraps Modal with a
 * standard "Are you sure?" body and a danger-styled confirm button.
 */

import React, { useState } from 'react';
import Modal from '../Modal';

export default function ConfirmDeleteModal({
  open,
  title = 'Delete this item?',
  message = 'This action cannot be undone.',
  confirmLabel = 'Delete',
  onConfirm,
  onClose,
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const handle = async () => {
    setBusy(true);
    setError(null);
    try {
      await onConfirm?.();
      setBusy(false);
      onClose?.();
    } catch (err) {
      setError(
        err.response?.data?.error || err.message || 'Delete failed',
      );
      setBusy(false);
    }
  };

  return (
    <Modal open={open} title={title} onClose={busy ? undefined : onClose}>
      <p>{message}</p>
      {error && <div className="form-error" style={{ marginTop: 12 }}>{error}</div>}
      <div className="form-actions">
        <button className="btn-secondary" onClick={onClose} disabled={busy}>
          Cancel
        </button>
        <button className="btn-danger" onClick={handle} disabled={busy}>
          {busy ? `${confirmLabel}…` : confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
